import React from 'react';
import { ModernButton } from '../ui/ModernButton';
import { AIChipIcon } from '../ui/Icons';

export function AISection({
  aiJobTitle,
  setAiJobTitle,
  generateAIQuestions,
  generateAITitle,
  isLoading,
  questions,
  aiShouldFillDescriptions,
  setAiShouldFillDescriptions,
}) {
  return (
    <div className="bg-white/90 dark:bg-slate-800/90 backdrop-blur-md border border-slate-200/60 dark:border-slate-700/60 p-6 rounded-2xl shadow-2xl dark:shadow-2xl mb-8 relative overflow-hidden transform transition-all duration-300 hover:scale-[1.01] hover:shadow-3xl isolate">
      {/* Enhanced AI Section 3D Glow (subtle so text stays sharp) */}
      <div className="pointer-events-none absolute -inset-2 z-0 bg-linear-to-r from-emerald-500 via-teal-600 to-green-500 rounded-2xl blur-lg opacity-10 animate-pulse"></div>
      <div className="pointer-events-none absolute -inset-1 z-0 bg-linear-to-r from-emerald-400 via-teal-500 to-green-400 rounded-2xl blur-md opacity-[0.08]"></div>
      <div className="pointer-events-none absolute -inset-0.5 z-0 bg-linear-to-r from-emerald-300 via-teal-400 to-green-300 rounded-2xl blur-xs opacity-[0.06]"></div>
      {/* Animated Border Effect */}
      <div className="pointer-events-none absolute -inset-0.5 z-0 bg-linear-to-r from-emerald-400 via-teal-500 to-green-400 rounded-2xl opacity-15 animate-pulse"></div>
      {/* Inner neutral surface for readability */}
      <div className="pointer-events-none absolute inset-0 z-0 bg-white/85 dark:bg-slate-800/85 rounded-2xl"></div>
      <div className="relative z-10">
        <h2 className="text-lg sm:text-xl font-bold ai-headline-darkgreen mb-3 flex items-center gap-2 drop-shadow-xs">
          <AIChipIcon className="h-7 w-7 md:h-8 md:w-8" />
          KI-Assistent
        </h2>
        <div className="space-y-4 relative z-10">
          <div>
            <label htmlFor="ai-job-title" className="block text-sm font-medium text-slate-700 dark:text-slate-300 mb-2">Fragen für Position vorschlagen:</label>
            <div className="flex gap-2">
              <input type="text" id="ai-job-title" value={aiJobTitle} onChange={(e) => setAiJobTitle(e.target.value)} placeholder="z.B. Marketing Manager" className="w-full p-3 border border-slate-300 dark:border-slate-700 dark:bg-slate-900 dark:text-slate-200 rounded-lg text-base shadow-inner bg-white dark:bg-slate-800" />
              <ModernButton
                onClick={generateAIQuestions}
                disabled={isLoading}
                loading={isLoading}
                variant="success"
                className="whitespace-nowrap px-6"
                icon={<svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 10V3L4 14h7v7l9-11h-7z" /></svg>}
              >
                Fragen ✨
              </ModernButton>
            </div>
          </div>

          <div className="flex gap-4">
            <div className="flex-1">
              <label className="block text-sm font-medium text-slate-700 dark:text-slate-300 mb-2">Titel basierend auf Fragen vorschlagen:</label>
              <ModernButton
                onClick={generateAITitle}
                disabled={isLoading || questions.length === 0}
                loading={isLoading}
                variant="success"
                size="lg"
                className="w-full"
                icon={<svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 10V3L4 14h7v7l9-11h-7z" /></svg>}
              >
                Titel vorschlagen ✨
              </ModernButton>
              {questions.length === 0 && !isLoading && (
                <p className="text-xs text-slate-500 dark:text-slate-400 mt-2 text-center italic">
                  Füge zuerst Fragen hinzu, um einen passenden Titel zu generieren
                </p>
              )}
            </div>
          </div>

          {/* Question descriptions checkbox */}
          <div className="flex justify-center">
            <label className="flex items-center gap-2 p-3 bg-white dark:bg-slate-700 rounded-xl border border-slate-200/80 dark:border-slate-600/80 shadow-lg hover:shadow-xl transition-all duration-200">
              <input
                type="checkbox"
                checked={aiShouldFillDescriptions}
                onChange={(e) => setAiShouldFillDescriptions(e.target.checked)}
                className="w-4 h-4 text-green-600 rounded focus:ring-green-500 border-slate-300 dark:border-slate-600 dark:bg-slate-700 shadow-inner"
              />
              <span className="text-sm text-slate-700 dark:text-slate-300 font-medium">
                Zusätzliche Beschreibungen für Fragen generieren
              </span>
            </label>
          </div>
        </div>
      </div>
    </div>
  );
}
